import axios from 'axios'

export function getGdpr(language) {
    let query
    language ? query = "?language=" + language : query = ""
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/gdpr/show-terms' + query, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}